module.exports = __webpack_public_path__ + "static/media/img-8.91edb7fe.jpg";